import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResendConfirmationEmailOption } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-resend-confirmation',
  templateUrl: './resend-confirmation.component.html',
  styleUrls: ['./resend-confirmation.component.scss'],
  standalone: false
})
export class ResendConfirmationComponent implements OnInit {
  resendOptions = Object.values(ResendConfirmationEmailOption);
  sendTo: ResendConfirmationEmailOption;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  cancel(): void {
    this.activeModal.close();
  }

  ok(): void {
    this.activeModal.close(this.sendTo);
  }
}
LightningModalTypes.ResendConfirmationComponent.component = ResendConfirmationComponent;
